<template>
  <div id="doorTask">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
              <el-form-item :label="$t('task.startTime')" >
                <el-date-picker
                  v-model="filterForm.dateRange"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                  align="right">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('filters.doorName')" >
                <span @click="onChooseDoor">
                  <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
                </span>
              </el-form-item>
              <el-form-item label="门店编号">
                <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('filters.region')" >
                <el-select v-model="filterForm.regionNo" multiple :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in regionOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.province')" >
                <el-select v-model="filterForm.provinceNo" multiple :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.city')" >
                <el-select v-model="filterForm.cityNo" multiple :placeholder="$t('filters.chooseCity')" @visible-change="getRangeList()">
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.reseller')" >
                <el-select v-model="filterForm.resellerNo" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in resellerOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.subReseller')" >
                <el-select v-model="filterForm.subReseller" multiple :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in subResellerOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="Cluster Name" >
                <el-select v-model="filterForm.clusterName" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in clusterNameOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="Concept" >
                <el-select v-model="filterForm.concept" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in conceptOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="City Tier" >
                <el-select v-model="filterForm.clusterGroup" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in cityTierOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Tz Group" >
                <el-select v-model="filterForm.tzGroup" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in tzGroupOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Format" >
                <el-select v-model="filterForm.format" multiple :placeholder="$t('choose')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in formatOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="HubDoor" >
                <el-select v-model="filterForm.hubDoor" clearable :placeholder="$t('choose')" @change="resetFilters()">
                  <el-option
                    v-for="item in hubDoorOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item> -->
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="24">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearchOut(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onExport()">{{ $t('export') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
            <p class="statistics">
              <span>任务总数: {{ todoTotal }}</span>
              <span>总任务完成数: {{ todoCompletions }}</span>
              <span>总完成率: {{ completionRate }}%</span>
            </p>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                fixed
                prop="doorName"
                :label="$t('filters.doorName')"
              >
              </el-table-column>
              <el-table-column
                prop="posId"
                label="门店编号">
              </el-table-column>
              <el-table-column
                prop="taskCount"
                :label="$t('task.taskNum')"
              >
              </el-table-column>
              <el-table-column
                prop="incompletion"
                :label="$t('task.notComplete')"
              >
              </el-table-column>
              <el-table-column
                prop="notReviewed"
                :label="$t('task.notAudit')"
              >
              </el-table-column>
              <el-table-column
                prop="completed"
                :label="$t('task.completed')"
              >
              </el-table-column>
              <el-table-column
                prop="completionRate"
                :label="$t('task.completeRate')"
              >
                <template slot-scope="scope">
                  {{scope.row.completionRate}}%
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                width="180">
                <template slot-scope="scope">
                  <el-button @click="openRateStatistics(scope.row.posId)" type="text" size="small">{{ $t('task.rateStatistics') }}</el-button>
                  <el-button @click="openTaskList(scope.row)" type="text" size="small">{{ $t('task.taskList') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
    <el-dialog :title="curDoorName" :visible.sync="rateDialogVisible">
      <div class="pieChart" id="pieChart">

      </div>
      <el-table
        :data="rateData"
        border
        style="width: 100%">
        <el-table-column
          prop="systemType"
          label="系统"
          width="180">
        </el-table-column>
        <el-table-column
          prop="todoTotal"
          label="任务数量">
        </el-table-column>
        <el-table-column
          prop="todoCompletions"
          label="已完成">
        </el-table-column>
        <el-table-column
          prop="todoIncompletion"
          label="未完成">
        </el-table-column>
        <el-table-column
          prop="todoNotReviewed"
          label="未审核">
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="$t('task.taskList')" :visible.sync="taskListDialogVisible">
      <el-form :inline="true" :model="taskListFilterForm" class="filterForm" label-width="80px">
        <el-form-item :label="$t('task.system')" >
          <el-select v-model="taskListFilterForm.systemType" :placeholder="$t('task.chooseSystem')">
            <el-option
              v-for="item in systemOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('task.taskStatus')">
          <el-select v-model="taskListFilterForm.status">
            <el-option
              v-for="item in statusOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="onSearchTaskList(true)">{{ $t('search') }}</el-button>
      </el-form>

      <el-table
        :data="taskListData"
        border
        style="width: 100%"
        v-loading="taskTableLoading"
      >
        <el-table-column
          prop="name"
          :label="$t('task.taskTitle')"
          width="180">
        </el-table-column>
        <el-table-column
          prop="startDate"
          :label="$t('task.startTime')"
        >
        </el-table-column>
        <el-table-column
          prop="endDate"
          :label="$t('task.endTime')"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('task.taskStatus')"
        >
        </el-table-column>
      </el-table>
      <div class="pagingBox">
        <el-pagination
          background
          @current-change="currentChangeTaskList"
          :current-page="tableConfigTaskList.current"
          layout="total, prev, pager, next"
          :total="totalTaskList">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { Chart } from '@antv/g2';
import PickDoor from "../../components/pickDoor";

export default {
  name: 'TaskManage',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      statusOptions: [],
      taskListData: [],
      currentPosId: '', //
      rateData: [], // 占比统计表格的数据
      curDoorName: '', // 当前占比统计的门店名称
      rateDialogVisible: false, //占比统计弹窗
      taskListDialogVisible: false, // 任务列表
      systemOptions: [
      ],
      taskListFilterForm: {}, // 任务列表的筛选条件
      initTaskListFilterForm: {
        systemType: '',
        status: ''
      },
      filterForm: {
        dateRange: [], // 时间范围
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        regionNo: '',
        provinceNo: '',
        cityNo: '',
        clusterName: '',
        concept: '',
        clusterGroup: '',
        tzGroup: '',
        format: '',
        resellerNo: '',
        subReseller: '',
        hubDoor: '',
        doorName: '',
        posId: '',
      },
      initFilterForm: {
        dateRange: '', // 时间范围
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        regionNo: '',
        provinceNo: '',
        cityNo: '',
        clusterName: '',
        concept: '',
        clusterGroup: '',
        tzGroup: '',
        format: '',
        resellerNo: '',
        subReseller: '',
        hubDoor: '',
        doorName: '',
        posId: '',
      },
      tableData: [], // 表格数据
      total: 0,
      totalTaskList: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableConfigTaskList: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      taskTableLoading: false,
      regionOptions: [
      ],
      provinceOptions: [
      ],
      cityOptions: [
      ],
      clusterNameOptions: [
      ],
      conceptOptions: [
      ],
      cityTierOptions: [
      ],
      tzGroupOptions: [
      ],
      formatOptions: [
      ],
      resellerOptions: [
      ],
      subResellerOptions: [
      ],
      hubDoorOptions: [
      ],
      todoTotal: 0,
      todoCompletions: 0,
      completionRate: 0,
      chart1: null,
    }
  },
  mounted () {
    this.getRangeList()
    this.onReset()
    this.getSystemOptions()
    this.getStatusOptions()
  },

  methods: {
    getSystemOptions: async function () {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType')
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        this.systemOptions = _.map(res.data, (system) => ({
          itemKey: system.code,
          itemValue: system.desc,
        }))
      }
    },
    getStatusOptions: async function () {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/taskSubStatus')
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        this.statusOptions = _.map(res.data, (system) => ({
          itemKey: system.code,
          itemValue: system.desc,
        }))
      }
    },
    // 打开占比统计弹窗
    openRateStatistics: function (posId) {
      this.rateDialogVisible = true
      this.getProportionStatistics(posId)
    },
    // 打开任务列表弹窗
    openTaskList: function (row){
      this.taskListDialogVisible = true
      this.currentPosId = row.posId
      this.taskListFilterForm = _.cloneDeep(this.initTaskListFilterForm)
      this.tableConfigTaskList.current = 1
      this.taskListData = []
    },
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNo': this.filterForm.cityNo,
        'clusterGroup': this.filterForm.clusterGroup,
        'clusterName': this.filterForm.clusterName,
        'concept': this.filterForm.concept,
        'resellerNo': this.filterForm.resellerNo,
        'subReseller': this.filterForm.subReseller,
        'format': this.filterForm.format,
        'provinceNo': this.filterForm.provinceNo,
        'regionNo': this.filterForm.regionNo,
        'tzGroup': this.filterForm.tzGroup,
        'hubDoor': this.filterForm.hubDoor
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailinkUrl + '/door/queryConditions', submitParams)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = res.regionList
      this.provinceOptions = res.provinceList
      this.cityOptions = res.cityList
      this.cityTierOptions = res.clusterGroupList
      this.clusterNameOptions = res.clusterNameList
      this.conceptOptions = res.conceptList
      this.formatOptions = res.formatList
      this.resellerOptions = res.resellerList
      this.subResellerOptions = res.subResellerList
      this.tzGroupOptions = res.tzGroupList
      this.hubDoorOptions = res.hubDoorList
    },
    async onExport() {
      const submitData = this.$tool.formatArrayToString(this.filterForm)
      submitData.current = this.tableConfig.current
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: window.retailinkUrl + "/toDo/doorToDoExport",
        data: submitData
      });
    },
    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    seeDetail() {
      // todo: 查看
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    currentChangeTaskList: function (index) {
      // 分页
      this.tableConfigTaskList.current = index
      this.onSearchTaskList(false)
    },
    onSearchOut: function() {
      this.getStatistics()
      this.onSearch(true)
    },
    getStatistics: async function () {
      let submitParams = this.$tool.formatArrayToString(this.filterForm)
      console.log('dateRange', submitParams.dateRange)
      submitParams.startTime = submitParams.dateRange ? submitParams.dateRange.split(',')[0] : ''
      submitParams.endTime = submitParams.dateRange ? submitParams.dateRange.split(',')[1] : ''
      let res = await window.instance.post(window.retailinkUrl + '/toDo/listDoorToDoStatistics', submitParams)
      res = res.data
      if (res.code === 200) {
        console.log('统计数据', res.data)
        this.todoTotal = res.data.todoTotal
        this.todoCompletions = res.data.todoCompletions
        this.completionRate = res.data.completionRate
      }
    },
    getProportionStatistics: async function (posId) {
      let submitParams = {
        posId: posId
      }
      submitParams.startTime = this.filterForm.dateRange ? this.filterForm.dateRange[0] : ''
      submitParams.endTime = this.filterForm.dateRange ? this.filterForm.dateRange[1] : ''
      let res = await window.instance.post(window.retailinkUrl + '/toDo/proportionStatistics', submitParams)
      res = res.data
      if (res.code === 200) {
        console.log('占比统计', res.data)
        this.curDoorName = res.data.doorName
        this.rateData = res.data.voList
        this.renderPieChart()
      }
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let submitParams = this.$tool.formatArrayToString(this.filterForm)
      console.log('submitParams', submitParams)
      submitParams.startTime = submitParams.dateRange ? submitParams.dateRange.split(',')[0] : ''
      submitParams.endTime = submitParams.dateRange ? submitParams.dateRange.split(',')[1] : ''
      let res = await window.instance.post(window.retailinkUrl + '/toDo/listToDoByDoor', _.assign(submitParams, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    // 查询任务列表
    onSearchTaskList: async function (resetPage) {
      if (resetPage) {
        this.tableConfigTaskList.current = 1
      }
      this.taskTableLoading = true
      const submitParams = {
        "posId": this.currentPosId,
        "status": this.taskListFilterForm.status,
        "systemType": this.taskListFilterForm.systemType
      }
      submitParams.startTime = this.filterForm.dateRange ? this.filterForm.dateRange[0] : ''
      submitParams.endTime = this.filterForm.dateRange ? this.filterForm.dateRange[1] : ''
      let res = await window.instance.post(window.retailinkUrl + '/toDo/doorToDo', _.assign(submitParams, this.tableConfigTaskList))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.totalTaskList = res.data.total
        this.taskListData = list
      }
      this.taskTableLoading = false
    },
    renderPieChart: function () {
      if (this.chart1) {
        this.chart1.destroy()
      }
      var totalNumber = 0
      _.each(this.rateData, (aData) => {
        totalNumber += aData.todoTotal
      })
      var data = [];
      _.each(this.rateData, (aData) => {
        data.push({
          item: aData.systemType,
          count: aData.todoTotal,
          percent: aData.todoTotal/totalNumber
        })
      })
      const chart = new Chart({
        container: 'pieChart',
        autoFit: true,
        height: 200,
      });

      chart.coordinate('theta', {
        radius: 0.75,
      });

      chart.data(data);

      chart.scale('percent', {
        formatter: (val) => {
          val = _.round(val * 100, 2) + '%';
          console.log('val', val)
          return val;
        },
      });

      chart.tooltip({
        showTitle: false,
        showMarkers: false,
      });

      chart
        .interval()
        .adjust('stack')
        .position('percent')
        .color('item')
        .label('count', {
          offset: '-30%',
          style: {
            textAlign: 'center',
            fontSize: 16,
            shadowBlur: 2,
            shadowColor: 'rgba(0, 0, 0, .45)',
          },
        })
        .tooltip('item*percent', (item, percent) => {
          percent = _.round(percent * 100, 2) + '%';
          return {
            name: item,
            value: percent,
          };
        });
      chart.legend(false); // 关闭下面的标示行

      chart.interaction('element-active');
      chart.theme({ "styleSheet": { "brandColor": "#ff6801", "paletteQualitative10": ["#ff6801", "#df9c3c", "#d5858f"], "paletteQualitative20": ["#ff6801", "#df9c3c", "#d5858f"] } });
      chart.render();
      this.chart1 = chart
    }
  }
}
</script>

<style scoped lang="sass">
.statistics
  color: #67c23a
  font-size: 14px
  margin: -30px 0 0 90px
  span
    margin-right: 20px
#doorTask

</style>



// WEBPACK FOOTER //
// src/pages/task/doorTask.vue